import script from "./RegistroAsistente.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroAsistente.vue?vue&type=script&setup=true&lang=js"

import "./RegistroAsistente.vue?vue&type=style&index=0&id=2ce5d24c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce5d24c"]])

export default __exports__